import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import {
  reducerUserReportsInputValues,
  reducerPending,
} from "../../../redux/reducer/userReports/reducers/userReports";
import { actionGetUserReports } from "../../../redux/action/userReports/actionUserReports";
import { AppDispatch } from "../../../redux/reducer/store";

import CircleLoader from "../../../components/custom/circleLoader/circleLoader";
import SectionContent from "../../../components/sectionContent/sectionContent";
import UserReports from "../../../pages/userReports/userReports/userReports";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const AdminReportsSection = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    reportsCount,
    reportsInputValues,
    limit,
    page,
    reportContracts,
    adminReportsSettings,
  } = useSelector((state: any) => state.userReports.userReports);
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const { claims } = useSelector((state: any) => state.user.user.data);
  const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");

  const buttonsContainerRef = useRef<HTMLDivElement>(null);
  const headFilterRef = useRef<any>(null);
  const reportsSettingsChechboxes = ["trainee", "refined", "notChecked"];
  let countDuplicateElements = 0;
  for (let i = 0; i < reportsSettingsChechboxes.length; i++) {
    if (adminReportsSettings.includes(reportsSettingsChechboxes[i])) {
      countDuplicateElements++;
    }
  }
  const widthChechboxes = countDuplicateElements * 76;
  const sidebarWidth = isOpenSidebar ? 190 : 44;
  const headerFiltersAndSelectWidth = widthChechboxes + 700;
  const minEmptyWidthForNewBtn = 300;
  const groupBtnWidth = 70;
  const buttonWidth = 130;

  const availableButtons = [
    {
      component: (
        <HeaderBtn
          content="Настройки"
          purpose="adminReportsSettings"
          modalTitle="Настройки"
        />
      ),
    },

    (claims.includes("admin") || claims.includes("reports:view")) && {
      component: (
        <>
          <HeaderBtn
            content="Выгрузить данные с ссылками"
            purpose="unloadReportsWithLinks"
            modalTitle="Сводный отчет"
            hasIcon="excel"
          />
        </>
      ),
    },

    (claims.includes("admin") || claims.includes("reports:view")) && {
      component: (
        <>
          <HeaderBtn
            content="Выгрузить данные"
            purpose="unloadReportsConsolidated"
            modalTitle="Сводный отчет"
            hasIcon="excel"
          />
        </>
      ),
    },

    reportContracts?.length > 0 &&
      (claims.includes("admin") || claims.includes("reports:view")) && {
        component: (
          <>
            <HeaderBtn
              content="Выгрузить отчет"
              purpose="unloadClientReport"
              modalTitle="Сводный отчет"
              hasIcon="excel"
            />
          </>
        ),
      },

    reportContracts?.length > 0 &&
      (claims.includes("admin") || claims.includes("reports:view")) && {
        component: (
          <>
            <HeaderBtn
              content="OSA за период"
              purpose="osa"
              modalTitle="OSA за период"
              hasIcon="excel"
            />
          </>
        ),
      },

    reportContracts?.length > 0 &&
      (claims.includes("admin") || claims.includes("reports:view")) && {
        component: (
          <>
            <HeaderBtn
              content="Средний фейсинг"
              purpose="averageFacing"
              modalTitle="Средний фейсинг"
              hasIcon="excel"
            />
          </>
        ),
      },

    reportsInputValues.contracts !== undefined && {
      component: (
        <>
          {
            <HeaderBtn
              content="Доля полки"
              purpose="shelfShare"
              modalTitle="Доля полки"
              hasIcon="excel"
            />
          }
        </>
      ),
    },

    reportContracts?.length > 0 &&
      (claims.includes("admin") || claims.includes("reports:view")) && {
        component: (
          <>
            <HeaderBtn
              content="Выгрузить гор. линию"
              purpose="unloadHotline"
              modalTitle="Сводный отчет"
              hasIcon="excel"
            />
          </>
        ),
      },

    (claims.includes("admin") || claims.includes("reports:view")) && {
      component: (
        <>
          <HeaderBtn
            content="Выгрузить список"
            purpose="unloadReportsList"
            modalTitle="Сводный отчет"
            hasIcon="excel"
          />
        </>
      ),
    },

    (claims.includes("admin") || claims.includes("reports:view")) && {
      component: (
        <>
          <HeaderBtn
            content="Выгрузить фото"
            purpose="unloadReportsPhotos"
            modalTitle="Выгрузить zip архив с фотоотчетом"
            hasIcon="zip"
          />
        </>
      ),
    },

    (claims.includes("admin") || claims.includes("reports:copy")) && {
      component: (
        <>
          <HeaderBtn
            content="Скопировать отчеты"
            purpose="copyReports"
            modalTitle="Скопировать отчеты"
          />
        </>
      ),
    },

    (claims.includes("admin") ||
      claims.includes("reports:update:delivery")) && {
      component: (
        <>
          <HeaderBtn
            content="Статус доставки"
            purpose="updateDeliveryStatus"
            modalTitle="Редактировать статус доставки отчетов"
          />
        </>
      ),
    },
    reportContracts?.length === 1 &&
      (claims.includes("admin") ||
        claims.includes("reports:update:review")) && {
        component: (
          <>
            <HeaderBtn
              content="Статус проверки"
              purpose="updateReviewStatus"
              modalTitle="Редактировать статус проверки отчетов"
            />
          </>
        ),
      },
    (claims.includes("admin") || claims.includes("reports:update:rate")) && {
      component: (
        <>
          <HeaderBtn
            content="Статус оценки"
            purpose="updateRateStatus"
            modalTitle="Редактировать статус оценки отчетов"
          />
        </>
      ),
    },

    (claims.includes("admin") || claims.includes("reports:geo:generate")) && {
      component: (
        <>
          <HeaderBtn
            content="Создать геолокацию"
            purpose="createGeo"
            modalTitle="Создание геолокации отчетов"
          />
        </>
      ),
    },

    (claims.includes("admin") || claims.includes("reports:import:kpi")) && {
      component: (
        <>
          <HeaderBtn
            content="Обновление KPI"
            purpose="uploadKPI"
            modalTitle="Загрузить KPI"
          />
        </>
      ),
    },
    (claims.includes("admin") || claims.includes("reports:import:logins")) && {
      component: (
        <>
          <HeaderBtn
            content="Загрузка логинов"
            purpose="logins"
            modalTitle="Загрузка логинов"
          />
        </>
      ),
    },
    (claims.includes("admin") || claims.includes("reports:import:new")) && {
      component: (
        <>
          <HeaderBtn
            content="Создание отчетов"
            purpose="newReportsCreation"
            modalTitle="Создание отчетов"
          />
        </>
      ),
    },
    // {
    // 	component: (
    // 		<>
    // 			<HeaderBtn
    // 				content='Выгрузить тандер'
    // 				purpose='unloadReportsTander'
    // 				modalTitle='Выгрузить тандер'
    // 				hasIcon='excel'
    // 			/>
    // 		</>
    // 	),
    // }
  ];

  const filteredAvailableButtons = availableButtons.filter(
    (btn: { component: JSX.Element }) => btn
  );

  useEffect(() => {
    const handleDocumentClick = () => {
      dispatch(
        reducerUserReportsInputValues({
          ...reportsInputValues,
          techInfo: inputValue,
        })
      );

      dispatch(actionGetUserReports(limit, page));

      setIsInputChange(false);
    };

    if (isInputChange) {
      document.addEventListener("click", handleDocumentClick);

      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
  }, [isInputChange, reportsInputValues, inputValue, dispatch, limit, page]);

  useEffect(() => {
    if (
      filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
      filteredAvailableButtons.length
    ) {
      setOverflowedBtnsCount(0);
    }
  }, [filteredAvailableButtons, overflowedBtnsCount]);

  const handleWindowResize = useCallback(() => {
    const allButtonsWidth =
      filteredAvailableButtons.slice(
        0,
        filteredAvailableButtons.length - overflowedBtnsCount
      ).length * buttonWidth;
    const spaceToLeftSideOfFilters =
      headFilterRef.current?.getBoundingClientRect().left;
    const windowWidth = window.innerWidth;
    const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
      : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

    if (isOverflowed) {
      setIsOpenGroupBtn(true);
      setOverflowedBtnsCount((prevValue: number) => {
        if (overflowedBtnsCount === filteredAvailableButtons.length) {
          return prevValue;
        } else {
          return overflowedBtnsCount + 1;
        }
      });
    }
    const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? spaceToLeftSideOfFilters -
          sidebarWidth -
          allButtonsWidth +
          groupBtnWidth >
        minEmptyWidthForNewBtn
      : spaceToLeftSideOfFilters - allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
    if (isEnoughtSpace) {
      setOverflowedBtnsCount((prevValue: number) => {
        if (prevValue <= 1) {
          setIsOpenGroupBtn(false);
          return 0;
        } else return prevValue - 1;
      });
    }
  }, [
    filteredAvailableButtons,
    overflowedBtnsCount,
    sidebarWidth,
    headerFiltersAndSelectWidth,
  ]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  const handleClickCheckbox = (name: string) => {
    if (reportsInputValues[name]) {
      const newReportsInputValues = { ...reportsInputValues };
      delete newReportsInputValues[name];
      dispatch(reducerUserReportsInputValues(newReportsInputValues));
    } else {
      dispatch(
        reducerUserReportsInputValues({
          ...reportsInputValues,
          [name]: !reportsInputValues[name],
        })
      );
    }
    dispatch(reducerPending(true));
    dispatch(actionGetUserReports(limit, page)).then(() => {
      dispatch(reducerPending(false));
    });
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setInputValue(value);
    setIsInputChange(true);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      dispatch(
        reducerUserReportsInputValues({
          ...reportsInputValues,
          techInfo: inputValue,
        })
      );

      dispatch(actionGetUserReports(limit, page));

      setIsInputChange(false);
    }
  };

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        availableButtons={displayedAvailableBtns}
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        pageName="reports"
        section="Отчеты"
        headBlockFilters={
          <div className="head__block_filters" ref={headFilterRef}>
            <div className="audit__filter_block">
              <span>Аудиты</span>
              <input
                defaultChecked={reportsInputValues.audit}
                onChange={() => handleClickCheckbox("audit")}
                type="checkbox"
              />
            </div>
            <div className="audit__filter_block">
              <span>Тандер</span>
              <input
                defaultChecked={reportsInputValues.tander}
                onChange={() => handleClickCheckbox("tander")}
                type="checkbox"
              />
            </div>
            {adminReportsSettings.includes("trainee") && (
              <div className="audit__filter_block">
                <span>Стажёр</span>
                <input
                  defaultChecked={reportsInputValues.trainee}
                  onChange={() => handleClickCheckbox("trainee")}
                  type="checkbox"
                />
              </div>
            )}
            {adminReportsSettings.includes("refined") && (
              <div className="audit__filter_block-nowrap">
                <span>Нарушитель</span>
                <input
                  defaultChecked={reportsInputValues.refined}
                  onChange={() => handleClickCheckbox("refined")}
                  type="checkbox"
                />
              </div>
            )}
            {adminReportsSettings.includes("notChecked") && (
              <div className="audit__filter_block-nowrap">
                <span>Не проверен</span>
                <input
                  defaultChecked={reportsInputValues.notChecked}
                  onChange={() => handleClickCheckbox("notChecked")}
                  type="checkbox"
                />
              </div>
            )}
            <input
              defaultValue={reportsInputValues.techInfo}
              onChange={handleInputChange}
              className="tech__info_input"
              onKeyPress={handleKeyPress}
              placeholder="Тех. инфо"
              type="text"
            />
          </div>
        }
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") || claims.includes("reports:view")) && (
              <Link to="/reports" className="tab">
                <div className="buttons__btn --active">
                  Всего
                  <div className="tab__reports_count">
                    {!reportsCount && reportsCount !== 0 ? (
                      <CircleLoader />
                    ) : (
                      reportsCount
                    )}
                  </div>
                </div>
              </Link>
            )}

            {(claims.includes("admin") ||
              claims.includes("reports:expired:view")) && (
              <Link to="/reports/expired" className="tab">
                <div className="buttons__btn">Не сданы</div>
              </Link>
            )}
          </div>
          <UserReports />
        </div>
      </SectionContent>
    </div>
  );
};

export default AdminReportsSection;
